module.exports = __webpack_public_path__ + "img/gravier_roule_africa.b16ee41e.jpg";